import { combineReducers } from 'redux';
import { LOCATION_CHANGE } from 'react-router-redux';
import {
  cond,
  always,
  T,
  compose,
  any,
  prop,
  values,
  gte,
  lt,
  __,
  both,
} from 'ramda';

import { types } from '../reducers/crimes';
import { fulfilled } from '../utils/helpers';

export const Populations = {
  Big: 'big',
  Medium: 'medium',
  Small: 'small',
  All: 'all',
};

export const SET_POPULATION = 'SET_POPULATION';

export const setPopulation = population => ({
  type: SET_POPULATION,
  payload: population,
});

const BIG_POPULATION = 1000000;
const MEDIUM_POPULATION = 500000;

// How to filter based on population presets
export const populationPredicates = {
  [Populations.Big]: gte(__, BIG_POPULATION),
  [Populations.Medium]: both(
    gte(__, MEDIUM_POPULATION),
    lt(__, BIG_POPULATION),
  ),
  [Populations.Small]: lt(__, MEDIUM_POPULATION),
  [Populations.All]: always(true),
};

const havePopulation = setting =>
  compose(
    any(any(crime => populationPredicates[setting](prop('population', crime)))),
    values,
  );

const getSuitableSetting = cond([
  [havePopulation(Populations.Big), always(Populations.Big)],
  [havePopulation(Populations.Medium), always(Populations.Medium)],
  [havePopulation(Populations.Small), always(Populations.Small)],
  [T, always(Populations.All)],
]);

const currentSettingReducer = (state = Populations.Big, action) =>
  action.type === SET_POPULATION ? action.payload : state;

const isInitialReducer = (state = true, action) =>
  action.type === LOCATION_CHANGE &&
  action.payload.pathname.match(/^(\/chart|\/table)/)
    ? false
    : state;

const firstSuitableSettingReducer = (state, action) =>
  action.type === fulfilled(types.FETCH_CITY_CRIMES) && state.isInitial
    ? {
        ...state,
        currentSetting: getSuitableSetting(action.payload),
      }
    : state;

export default (state, action) => {
  const populationReducer = combineReducers({
    currentSetting: currentSettingReducer,
    isInitial: isInitialReducer,
  });

  const nextState = populationReducer(state, action);

  return firstSuitableSettingReducer(nextState, action);
};

export const getPopulationSetting = state => state.population.currentSetting;



// WEBPACK FOOTER //
// ./src/reducers/population.js